import { render, staticRenderFns } from "./FormArray.vue?vue&type=template&id=0233f7be&scoped=true&"
import script from "./FormArray.vue?vue&type=script&lang=js&"
export * from "./FormArray.vue?vue&type=script&lang=js&"
import style0 from "./FormArray.vue?vue&type=style&index=0&id=0233f7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233f7be",
  null
  
)

export default component.exports